// ESM-Huelle um lib/scripts/pos/netcomm/CLS_CInputStream.js (Phase 4, Welle 4b).
// Prototype-Stil bleibt vorerst.
//******************************************************************************
// CInputStream
//******************************************************************************
// Description:
//      Creates an input stream and attaches a listener on it. Incoming data is
//      sent to a callback function.
// Parameters:
//      transport - Pointer to a transport object.
//      dataCallback - Pointer to the callback function of type 'function (class,
//          data, host)'.
//******************************************************************************

// *** Constructor ***
function CInputStream (transport, dataCallback)
{
    /*privMan.enablePrivilege (privList);*/

    this.streamIf = transport.openInputStream (0, 0, 0);
/*
    this.stream = Components.classes["@mozilla.org/scriptableinputstream;1"].
        createInstance(Components.interfaces.nsIScriptableInputStream);
    */
    this.stream.init (this.streamIf);
/*
    this.inPump = Components.classes["@mozilla.org/network/input-stream-pump;1"].
        createInstance(Components.interfaces.nsIInputStreamPump);
    */
    this.dataListener = new CDataListener (this.stream, transport.host, dataCallback);

    this.inPump.init (this.streamIf, -1, -1, 0, 0, false);    
    this.inPump.asyncRead (this.dataListener, null);
}
// ***

// *** Class variables ***
CInputStream.prototype.streamIf = null;
CInputStream.prototype.inPump = null;
CInputStream.prototype.dataListener = null;
CInputStream.prototype.stream = null;
// ***

//******************************************************************************
export { CInputStream };
